export default "__VITE_ASSET__Cij4p8yp__"